import Link from 'next/link';
import SubMenu from './SubMenu';
import SearchBar from './SearchBar';
import { NavBarRoutes } from '@/data/businessData';
import { useMemo, useState } from 'react';
import searchIconWhite from '/public/icons/searchIcon.png';
import Image from 'next/image';

const DesktopNavigation = () => {
  const navRoutes = useMemo(() => Object.values(NavBarRoutes), []);
  const [showSearch, setShowSearch] = useState(false);

  if (showSearch) {
    return <SearchBar variant="desktop" showSearch={showSearch} setShowSearch={setShowSearch} />;
  }

  return (
    <div className="w-full items-center justify-end px-8 py-4">
      <div className="flex items-center text-xl text-nowrap text-white lg:gap-6 xl:gap-8">
        {navRoutes.map((route) => {
          return (
            <div key={route.label} className="group relative">
              {route.href === '' ? (
                <button
                  type="button"
                  tabIndex={0}
                  aria-haspopup="true"
                  className="inline-block text-white uppercase transition-transform duration-200 hover:scale-110"
                  onClick={(e) => e.currentTarget.blur()}
                >
                  {route.label}
                </button>
              ) : (
                <Link
                  href={route.href}
                  className="inline-block cursor-pointer text-white uppercase transition-transform duration-200 hover:scale-110"
                  onClick={(e) => e.currentTarget.blur()}
                >
                  {route.label}
                </Link>
              )}

              {route.hasSubLinks && (
                <div
                  className={`absolute right-0 z-50 hidden flex-col gap-4 bg-[#000000]/90 p-6 text-white shadow-lg group-focus-within:flex group-hover:flex`}
                >
                  <SubMenu routes={route.subLinks} />
                </div>
              )}
            </div>
          );
        })}

        {/* Trigger icon */}
        {!showSearch && (
          <button
            type="button"
            className="relative ml-4 flex min-h-[44px] min-w-[20px] cursor-pointer items-center justify-center transition-transform duration-200 hover:scale-110 focus:ring-2 focus:ring-white focus:ring-offset-2 focus:outline-none"
            onClick={() => setShowSearch(true)}
            aria-label="Open search bar"
            title="Search"
          >
            <Image src={searchIconWhite} alt="" width={18} height={18} className="min-w-[18px]" />
          </button>
        )}
      </div>
    </div>
  );
};

export default DesktopNavigation;
